import { createI18n } from 'vue-i18n';
import tr from '@/locales/tr/index.js';

const i18n = createI18n({
  legacy: false,
  locale: 'tr',
  fallbackLocale: 'tr',
  messages: { tr },
});

export default i18n;
